import { __assign } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
import { Distribution, DistributionConfig, } from "./models_0";
export var DeleteMonitoringSubscriptionResult;
(function (DeleteMonitoringSubscriptionResult) {
    DeleteMonitoringSubscriptionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMonitoringSubscriptionResult || (DeleteMonitoringSubscriptionResult = {}));
export var DeleteOriginRequestPolicyRequest;
(function (DeleteOriginRequestPolicyRequest) {
    DeleteOriginRequestPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteOriginRequestPolicyRequest || (DeleteOriginRequestPolicyRequest = {}));
export var DeletePublicKeyRequest;
(function (DeletePublicKeyRequest) {
    DeletePublicKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeletePublicKeyRequest || (DeletePublicKeyRequest = {}));
export var DeleteRealtimeLogConfigRequest;
(function (DeleteRealtimeLogConfigRequest) {
    DeleteRealtimeLogConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteRealtimeLogConfigRequest || (DeleteRealtimeLogConfigRequest = {}));
export var DeleteResponseHeadersPolicyRequest;
(function (DeleteResponseHeadersPolicyRequest) {
    DeleteResponseHeadersPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteResponseHeadersPolicyRequest || (DeleteResponseHeadersPolicyRequest = {}));
export var DeleteStreamingDistributionRequest;
(function (DeleteStreamingDistributionRequest) {
    DeleteStreamingDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteStreamingDistributionRequest || (DeleteStreamingDistributionRequest = {}));
export var DescribeFunctionRequest;
(function (DescribeFunctionRequest) {
    DescribeFunctionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeFunctionRequest || (DescribeFunctionRequest = {}));
export var DescribeFunctionResult;
(function (DescribeFunctionResult) {
    DescribeFunctionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeFunctionResult || (DescribeFunctionResult = {}));
export var GetCachePolicyRequest;
(function (GetCachePolicyRequest) {
    GetCachePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCachePolicyRequest || (GetCachePolicyRequest = {}));
export var GetCachePolicyResult;
(function (GetCachePolicyResult) {
    GetCachePolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCachePolicyResult || (GetCachePolicyResult = {}));
export var GetCachePolicyConfigRequest;
(function (GetCachePolicyConfigRequest) {
    GetCachePolicyConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCachePolicyConfigRequest || (GetCachePolicyConfigRequest = {}));
export var GetCachePolicyConfigResult;
(function (GetCachePolicyConfigResult) {
    GetCachePolicyConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCachePolicyConfigResult || (GetCachePolicyConfigResult = {}));
export var GetCloudFrontOriginAccessIdentityRequest;
(function (GetCloudFrontOriginAccessIdentityRequest) {
    GetCloudFrontOriginAccessIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCloudFrontOriginAccessIdentityRequest || (GetCloudFrontOriginAccessIdentityRequest = {}));
export var GetCloudFrontOriginAccessIdentityResult;
(function (GetCloudFrontOriginAccessIdentityResult) {
    GetCloudFrontOriginAccessIdentityResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCloudFrontOriginAccessIdentityResult || (GetCloudFrontOriginAccessIdentityResult = {}));
export var GetCloudFrontOriginAccessIdentityConfigRequest;
(function (GetCloudFrontOriginAccessIdentityConfigRequest) {
    GetCloudFrontOriginAccessIdentityConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCloudFrontOriginAccessIdentityConfigRequest || (GetCloudFrontOriginAccessIdentityConfigRequest = {}));
export var GetCloudFrontOriginAccessIdentityConfigResult;
(function (GetCloudFrontOriginAccessIdentityConfigResult) {
    GetCloudFrontOriginAccessIdentityConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCloudFrontOriginAccessIdentityConfigResult || (GetCloudFrontOriginAccessIdentityConfigResult = {}));
export var GetDistributionRequest;
(function (GetDistributionRequest) {
    GetDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetDistributionRequest || (GetDistributionRequest = {}));
export var GetDistributionResult;
(function (GetDistributionResult) {
    GetDistributionResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Distribution && { Distribution: Distribution.filterSensitiveLog(obj.Distribution) }))); };
})(GetDistributionResult || (GetDistributionResult = {}));
export var GetDistributionConfigRequest;
(function (GetDistributionConfigRequest) {
    GetDistributionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetDistributionConfigRequest || (GetDistributionConfigRequest = {}));
export var GetDistributionConfigResult;
(function (GetDistributionConfigResult) {
    GetDistributionConfigResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfig && {
        DistributionConfig: DistributionConfig.filterSensitiveLog(obj.DistributionConfig),
    }))); };
})(GetDistributionConfigResult || (GetDistributionConfigResult = {}));
export var GetFieldLevelEncryptionRequest;
(function (GetFieldLevelEncryptionRequest) {
    GetFieldLevelEncryptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionRequest || (GetFieldLevelEncryptionRequest = {}));
export var GetFieldLevelEncryptionResult;
(function (GetFieldLevelEncryptionResult) {
    GetFieldLevelEncryptionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionResult || (GetFieldLevelEncryptionResult = {}));
export var GetFieldLevelEncryptionConfigRequest;
(function (GetFieldLevelEncryptionConfigRequest) {
    GetFieldLevelEncryptionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionConfigRequest || (GetFieldLevelEncryptionConfigRequest = {}));
export var GetFieldLevelEncryptionConfigResult;
(function (GetFieldLevelEncryptionConfigResult) {
    GetFieldLevelEncryptionConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionConfigResult || (GetFieldLevelEncryptionConfigResult = {}));
export var GetFieldLevelEncryptionProfileRequest;
(function (GetFieldLevelEncryptionProfileRequest) {
    GetFieldLevelEncryptionProfileRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionProfileRequest || (GetFieldLevelEncryptionProfileRequest = {}));
export var GetFieldLevelEncryptionProfileResult;
(function (GetFieldLevelEncryptionProfileResult) {
    GetFieldLevelEncryptionProfileResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionProfileResult || (GetFieldLevelEncryptionProfileResult = {}));
export var GetFieldLevelEncryptionProfileConfigRequest;
(function (GetFieldLevelEncryptionProfileConfigRequest) {
    GetFieldLevelEncryptionProfileConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionProfileConfigRequest || (GetFieldLevelEncryptionProfileConfigRequest = {}));
export var GetFieldLevelEncryptionProfileConfigResult;
(function (GetFieldLevelEncryptionProfileConfigResult) {
    GetFieldLevelEncryptionProfileConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFieldLevelEncryptionProfileConfigResult || (GetFieldLevelEncryptionProfileConfigResult = {}));
export var GetFunctionRequest;
(function (GetFunctionRequest) {
    GetFunctionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFunctionRequest || (GetFunctionRequest = {}));
export var GetFunctionResult;
(function (GetFunctionResult) {
    GetFunctionResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.FunctionCode && { FunctionCode: SENSITIVE_STRING }))); };
})(GetFunctionResult || (GetFunctionResult = {}));
export var GetInvalidationRequest;
(function (GetInvalidationRequest) {
    GetInvalidationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetInvalidationRequest || (GetInvalidationRequest = {}));
export var GetInvalidationResult;
(function (GetInvalidationResult) {
    GetInvalidationResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetInvalidationResult || (GetInvalidationResult = {}));
export var GetKeyGroupRequest;
(function (GetKeyGroupRequest) {
    GetKeyGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetKeyGroupRequest || (GetKeyGroupRequest = {}));
export var GetKeyGroupResult;
(function (GetKeyGroupResult) {
    GetKeyGroupResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetKeyGroupResult || (GetKeyGroupResult = {}));
export var GetKeyGroupConfigRequest;
(function (GetKeyGroupConfigRequest) {
    GetKeyGroupConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetKeyGroupConfigRequest || (GetKeyGroupConfigRequest = {}));
export var GetKeyGroupConfigResult;
(function (GetKeyGroupConfigResult) {
    GetKeyGroupConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetKeyGroupConfigResult || (GetKeyGroupConfigResult = {}));
export var GetMonitoringSubscriptionRequest;
(function (GetMonitoringSubscriptionRequest) {
    GetMonitoringSubscriptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetMonitoringSubscriptionRequest || (GetMonitoringSubscriptionRequest = {}));
export var GetMonitoringSubscriptionResult;
(function (GetMonitoringSubscriptionResult) {
    GetMonitoringSubscriptionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetMonitoringSubscriptionResult || (GetMonitoringSubscriptionResult = {}));
export var GetOriginRequestPolicyRequest;
(function (GetOriginRequestPolicyRequest) {
    GetOriginRequestPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetOriginRequestPolicyRequest || (GetOriginRequestPolicyRequest = {}));
export var GetOriginRequestPolicyResult;
(function (GetOriginRequestPolicyResult) {
    GetOriginRequestPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetOriginRequestPolicyResult || (GetOriginRequestPolicyResult = {}));
export var GetOriginRequestPolicyConfigRequest;
(function (GetOriginRequestPolicyConfigRequest) {
    GetOriginRequestPolicyConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetOriginRequestPolicyConfigRequest || (GetOriginRequestPolicyConfigRequest = {}));
export var GetOriginRequestPolicyConfigResult;
(function (GetOriginRequestPolicyConfigResult) {
    GetOriginRequestPolicyConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetOriginRequestPolicyConfigResult || (GetOriginRequestPolicyConfigResult = {}));
export var GetPublicKeyRequest;
(function (GetPublicKeyRequest) {
    GetPublicKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPublicKeyRequest || (GetPublicKeyRequest = {}));
export var GetPublicKeyResult;
(function (GetPublicKeyResult) {
    GetPublicKeyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPublicKeyResult || (GetPublicKeyResult = {}));
export var GetPublicKeyConfigRequest;
(function (GetPublicKeyConfigRequest) {
    GetPublicKeyConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPublicKeyConfigRequest || (GetPublicKeyConfigRequest = {}));
export var GetPublicKeyConfigResult;
(function (GetPublicKeyConfigResult) {
    GetPublicKeyConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPublicKeyConfigResult || (GetPublicKeyConfigResult = {}));
export var GetRealtimeLogConfigRequest;
(function (GetRealtimeLogConfigRequest) {
    GetRealtimeLogConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetRealtimeLogConfigRequest || (GetRealtimeLogConfigRequest = {}));
export var GetRealtimeLogConfigResult;
(function (GetRealtimeLogConfigResult) {
    GetRealtimeLogConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetRealtimeLogConfigResult || (GetRealtimeLogConfigResult = {}));
export var GetResponseHeadersPolicyRequest;
(function (GetResponseHeadersPolicyRequest) {
    GetResponseHeadersPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetResponseHeadersPolicyRequest || (GetResponseHeadersPolicyRequest = {}));
export var GetResponseHeadersPolicyResult;
(function (GetResponseHeadersPolicyResult) {
    GetResponseHeadersPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetResponseHeadersPolicyResult || (GetResponseHeadersPolicyResult = {}));
export var GetResponseHeadersPolicyConfigRequest;
(function (GetResponseHeadersPolicyConfigRequest) {
    GetResponseHeadersPolicyConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetResponseHeadersPolicyConfigRequest || (GetResponseHeadersPolicyConfigRequest = {}));
export var GetResponseHeadersPolicyConfigResult;
(function (GetResponseHeadersPolicyConfigResult) {
    GetResponseHeadersPolicyConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetResponseHeadersPolicyConfigResult || (GetResponseHeadersPolicyConfigResult = {}));
export var GetStreamingDistributionRequest;
(function (GetStreamingDistributionRequest) {
    GetStreamingDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetStreamingDistributionRequest || (GetStreamingDistributionRequest = {}));
export var GetStreamingDistributionResult;
(function (GetStreamingDistributionResult) {
    GetStreamingDistributionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetStreamingDistributionResult || (GetStreamingDistributionResult = {}));
export var GetStreamingDistributionConfigRequest;
(function (GetStreamingDistributionConfigRequest) {
    GetStreamingDistributionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetStreamingDistributionConfigRequest || (GetStreamingDistributionConfigRequest = {}));
export var GetStreamingDistributionConfigResult;
(function (GetStreamingDistributionConfigResult) {
    GetStreamingDistributionConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetStreamingDistributionConfigResult || (GetStreamingDistributionConfigResult = {}));
export var ListCachePoliciesRequest;
(function (ListCachePoliciesRequest) {
    ListCachePoliciesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCachePoliciesRequest || (ListCachePoliciesRequest = {}));
export var ListCachePoliciesResult;
(function (ListCachePoliciesResult) {
    ListCachePoliciesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCachePoliciesResult || (ListCachePoliciesResult = {}));
export var ListCloudFrontOriginAccessIdentitiesRequest;
(function (ListCloudFrontOriginAccessIdentitiesRequest) {
    ListCloudFrontOriginAccessIdentitiesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCloudFrontOriginAccessIdentitiesRequest || (ListCloudFrontOriginAccessIdentitiesRequest = {}));
export var CloudFrontOriginAccessIdentitySummary;
(function (CloudFrontOriginAccessIdentitySummary) {
    CloudFrontOriginAccessIdentitySummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CloudFrontOriginAccessIdentitySummary || (CloudFrontOriginAccessIdentitySummary = {}));
export var CloudFrontOriginAccessIdentityList;
(function (CloudFrontOriginAccessIdentityList) {
    CloudFrontOriginAccessIdentityList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CloudFrontOriginAccessIdentityList || (CloudFrontOriginAccessIdentityList = {}));
export var ListCloudFrontOriginAccessIdentitiesResult;
(function (ListCloudFrontOriginAccessIdentitiesResult) {
    ListCloudFrontOriginAccessIdentitiesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCloudFrontOriginAccessIdentitiesResult || (ListCloudFrontOriginAccessIdentitiesResult = {}));
export var ListConflictingAliasesRequest;
(function (ListConflictingAliasesRequest) {
    ListConflictingAliasesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListConflictingAliasesRequest || (ListConflictingAliasesRequest = {}));
export var ConflictingAlias;
(function (ConflictingAlias) {
    ConflictingAlias.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ConflictingAlias || (ConflictingAlias = {}));
export var ConflictingAliasesList;
(function (ConflictingAliasesList) {
    ConflictingAliasesList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ConflictingAliasesList || (ConflictingAliasesList = {}));
export var ListConflictingAliasesResult;
(function (ListConflictingAliasesResult) {
    ListConflictingAliasesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListConflictingAliasesResult || (ListConflictingAliasesResult = {}));
export var ListDistributionsRequest;
(function (ListDistributionsRequest) {
    ListDistributionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsRequest || (ListDistributionsRequest = {}));
export var DistributionSummary;
(function (DistributionSummary) {
    DistributionSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DistributionSummary || (DistributionSummary = {}));
export var DistributionList;
(function (DistributionList) {
    DistributionList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DistributionList || (DistributionList = {}));
export var ListDistributionsResult;
(function (ListDistributionsResult) {
    ListDistributionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsResult || (ListDistributionsResult = {}));
export var ListDistributionsByCachePolicyIdRequest;
(function (ListDistributionsByCachePolicyIdRequest) {
    ListDistributionsByCachePolicyIdRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByCachePolicyIdRequest || (ListDistributionsByCachePolicyIdRequest = {}));
export var DistributionIdList;
(function (DistributionIdList) {
    DistributionIdList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DistributionIdList || (DistributionIdList = {}));
export var ListDistributionsByCachePolicyIdResult;
(function (ListDistributionsByCachePolicyIdResult) {
    ListDistributionsByCachePolicyIdResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByCachePolicyIdResult || (ListDistributionsByCachePolicyIdResult = {}));
export var ListDistributionsByKeyGroupRequest;
(function (ListDistributionsByKeyGroupRequest) {
    ListDistributionsByKeyGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByKeyGroupRequest || (ListDistributionsByKeyGroupRequest = {}));
export var ListDistributionsByKeyGroupResult;
(function (ListDistributionsByKeyGroupResult) {
    ListDistributionsByKeyGroupResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByKeyGroupResult || (ListDistributionsByKeyGroupResult = {}));
export var ListDistributionsByOriginRequestPolicyIdRequest;
(function (ListDistributionsByOriginRequestPolicyIdRequest) {
    ListDistributionsByOriginRequestPolicyIdRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByOriginRequestPolicyIdRequest || (ListDistributionsByOriginRequestPolicyIdRequest = {}));
export var ListDistributionsByOriginRequestPolicyIdResult;
(function (ListDistributionsByOriginRequestPolicyIdResult) {
    ListDistributionsByOriginRequestPolicyIdResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByOriginRequestPolicyIdResult || (ListDistributionsByOriginRequestPolicyIdResult = {}));
export var ListDistributionsByRealtimeLogConfigRequest;
(function (ListDistributionsByRealtimeLogConfigRequest) {
    ListDistributionsByRealtimeLogConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByRealtimeLogConfigRequest || (ListDistributionsByRealtimeLogConfigRequest = {}));
export var ListDistributionsByRealtimeLogConfigResult;
(function (ListDistributionsByRealtimeLogConfigResult) {
    ListDistributionsByRealtimeLogConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByRealtimeLogConfigResult || (ListDistributionsByRealtimeLogConfigResult = {}));
export var ListDistributionsByResponseHeadersPolicyIdRequest;
(function (ListDistributionsByResponseHeadersPolicyIdRequest) {
    ListDistributionsByResponseHeadersPolicyIdRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByResponseHeadersPolicyIdRequest || (ListDistributionsByResponseHeadersPolicyIdRequest = {}));
export var ListDistributionsByResponseHeadersPolicyIdResult;
(function (ListDistributionsByResponseHeadersPolicyIdResult) {
    ListDistributionsByResponseHeadersPolicyIdResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByResponseHeadersPolicyIdResult || (ListDistributionsByResponseHeadersPolicyIdResult = {}));
export var ListDistributionsByWebACLIdRequest;
(function (ListDistributionsByWebACLIdRequest) {
    ListDistributionsByWebACLIdRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByWebACLIdRequest || (ListDistributionsByWebACLIdRequest = {}));
export var ListDistributionsByWebACLIdResult;
(function (ListDistributionsByWebACLIdResult) {
    ListDistributionsByWebACLIdResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListDistributionsByWebACLIdResult || (ListDistributionsByWebACLIdResult = {}));
export var ListFieldLevelEncryptionConfigsRequest;
(function (ListFieldLevelEncryptionConfigsRequest) {
    ListFieldLevelEncryptionConfigsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFieldLevelEncryptionConfigsRequest || (ListFieldLevelEncryptionConfigsRequest = {}));
export var FieldLevelEncryptionSummary;
(function (FieldLevelEncryptionSummary) {
    FieldLevelEncryptionSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionSummary || (FieldLevelEncryptionSummary = {}));
export var FieldLevelEncryptionList;
(function (FieldLevelEncryptionList) {
    FieldLevelEncryptionList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionList || (FieldLevelEncryptionList = {}));
export var ListFieldLevelEncryptionConfigsResult;
(function (ListFieldLevelEncryptionConfigsResult) {
    ListFieldLevelEncryptionConfigsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFieldLevelEncryptionConfigsResult || (ListFieldLevelEncryptionConfigsResult = {}));
export var ListFieldLevelEncryptionProfilesRequest;
(function (ListFieldLevelEncryptionProfilesRequest) {
    ListFieldLevelEncryptionProfilesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFieldLevelEncryptionProfilesRequest || (ListFieldLevelEncryptionProfilesRequest = {}));
export var FieldLevelEncryptionProfileSummary;
(function (FieldLevelEncryptionProfileSummary) {
    FieldLevelEncryptionProfileSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionProfileSummary || (FieldLevelEncryptionProfileSummary = {}));
export var FieldLevelEncryptionProfileList;
(function (FieldLevelEncryptionProfileList) {
    FieldLevelEncryptionProfileList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionProfileList || (FieldLevelEncryptionProfileList = {}));
export var ListFieldLevelEncryptionProfilesResult;
(function (ListFieldLevelEncryptionProfilesResult) {
    ListFieldLevelEncryptionProfilesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFieldLevelEncryptionProfilesResult || (ListFieldLevelEncryptionProfilesResult = {}));
export var ListFunctionsRequest;
(function (ListFunctionsRequest) {
    ListFunctionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFunctionsRequest || (ListFunctionsRequest = {}));
export var FunctionList;
(function (FunctionList) {
    FunctionList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionList || (FunctionList = {}));
export var ListFunctionsResult;
(function (ListFunctionsResult) {
    ListFunctionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFunctionsResult || (ListFunctionsResult = {}));
export var ListInvalidationsRequest;
(function (ListInvalidationsRequest) {
    ListInvalidationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListInvalidationsRequest || (ListInvalidationsRequest = {}));
export var InvalidationSummary;
(function (InvalidationSummary) {
    InvalidationSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidationSummary || (InvalidationSummary = {}));
export var InvalidationList;
(function (InvalidationList) {
    InvalidationList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidationList || (InvalidationList = {}));
export var ListInvalidationsResult;
(function (ListInvalidationsResult) {
    ListInvalidationsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListInvalidationsResult || (ListInvalidationsResult = {}));
export var ListKeyGroupsRequest;
(function (ListKeyGroupsRequest) {
    ListKeyGroupsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListKeyGroupsRequest || (ListKeyGroupsRequest = {}));
export var KeyGroupSummary;
(function (KeyGroupSummary) {
    KeyGroupSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyGroupSummary || (KeyGroupSummary = {}));
export var KeyGroupList;
(function (KeyGroupList) {
    KeyGroupList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyGroupList || (KeyGroupList = {}));
export var ListKeyGroupsResult;
(function (ListKeyGroupsResult) {
    ListKeyGroupsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListKeyGroupsResult || (ListKeyGroupsResult = {}));
export var ListOriginRequestPoliciesRequest;
(function (ListOriginRequestPoliciesRequest) {
    ListOriginRequestPoliciesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListOriginRequestPoliciesRequest || (ListOriginRequestPoliciesRequest = {}));
export var OriginRequestPolicySummary;
(function (OriginRequestPolicySummary) {
    OriginRequestPolicySummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicySummary || (OriginRequestPolicySummary = {}));
export var OriginRequestPolicyList;
(function (OriginRequestPolicyList) {
    OriginRequestPolicyList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicyList || (OriginRequestPolicyList = {}));
export var ListOriginRequestPoliciesResult;
(function (ListOriginRequestPoliciesResult) {
    ListOriginRequestPoliciesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListOriginRequestPoliciesResult || (ListOriginRequestPoliciesResult = {}));
export var ListPublicKeysRequest;
(function (ListPublicKeysRequest) {
    ListPublicKeysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListPublicKeysRequest || (ListPublicKeysRequest = {}));
export var PublicKeySummary;
(function (PublicKeySummary) {
    PublicKeySummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicKeySummary || (PublicKeySummary = {}));
export var PublicKeyList;
(function (PublicKeyList) {
    PublicKeyList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicKeyList || (PublicKeyList = {}));
export var ListPublicKeysResult;
(function (ListPublicKeysResult) {
    ListPublicKeysResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListPublicKeysResult || (ListPublicKeysResult = {}));
export var ListRealtimeLogConfigsRequest;
(function (ListRealtimeLogConfigsRequest) {
    ListRealtimeLogConfigsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListRealtimeLogConfigsRequest || (ListRealtimeLogConfigsRequest = {}));
export var RealtimeLogConfigs;
(function (RealtimeLogConfigs) {
    RealtimeLogConfigs.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RealtimeLogConfigs || (RealtimeLogConfigs = {}));
export var ListRealtimeLogConfigsResult;
(function (ListRealtimeLogConfigsResult) {
    ListRealtimeLogConfigsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListRealtimeLogConfigsResult || (ListRealtimeLogConfigsResult = {}));
export var ResponseHeadersPolicyType;
(function (ResponseHeadersPolicyType) {
    ResponseHeadersPolicyType["custom"] = "custom";
    ResponseHeadersPolicyType["managed"] = "managed";
})(ResponseHeadersPolicyType || (ResponseHeadersPolicyType = {}));
export var ListResponseHeadersPoliciesRequest;
(function (ListResponseHeadersPoliciesRequest) {
    ListResponseHeadersPoliciesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListResponseHeadersPoliciesRequest || (ListResponseHeadersPoliciesRequest = {}));
export var ResponseHeadersPolicySummary;
(function (ResponseHeadersPolicySummary) {
    ResponseHeadersPolicySummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicySummary || (ResponseHeadersPolicySummary = {}));
export var ResponseHeadersPolicyList;
(function (ResponseHeadersPolicyList) {
    ResponseHeadersPolicyList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyList || (ResponseHeadersPolicyList = {}));
export var ListResponseHeadersPoliciesResult;
(function (ListResponseHeadersPoliciesResult) {
    ListResponseHeadersPoliciesResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListResponseHeadersPoliciesResult || (ListResponseHeadersPoliciesResult = {}));
export var ListStreamingDistributionsRequest;
(function (ListStreamingDistributionsRequest) {
    ListStreamingDistributionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListStreamingDistributionsRequest || (ListStreamingDistributionsRequest = {}));
export var StreamingDistributionSummary;
(function (StreamingDistributionSummary) {
    StreamingDistributionSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingDistributionSummary || (StreamingDistributionSummary = {}));
export var StreamingDistributionList;
(function (StreamingDistributionList) {
    StreamingDistributionList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingDistributionList || (StreamingDistributionList = {}));
export var ListStreamingDistributionsResult;
(function (ListStreamingDistributionsResult) {
    ListStreamingDistributionsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListStreamingDistributionsResult || (ListStreamingDistributionsResult = {}));
export var ListTagsForResourceRequest;
(function (ListTagsForResourceRequest) {
    ListTagsForResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListTagsForResourceRequest || (ListTagsForResourceRequest = {}));
export var ListTagsForResourceResult;
(function (ListTagsForResourceResult) {
    ListTagsForResourceResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListTagsForResourceResult || (ListTagsForResourceResult = {}));
export var PublishFunctionRequest;
(function (PublishFunctionRequest) {
    PublishFunctionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublishFunctionRequest || (PublishFunctionRequest = {}));
export var PublishFunctionResult;
(function (PublishFunctionResult) {
    PublishFunctionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublishFunctionResult || (PublishFunctionResult = {}));
export var TagResourceRequest;
(function (TagResourceRequest) {
    TagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagResourceRequest || (TagResourceRequest = {}));
export var TestFunctionRequest;
(function (TestFunctionRequest) {
    TestFunctionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.EventObject && { EventObject: SENSITIVE_STRING }))); };
})(TestFunctionRequest || (TestFunctionRequest = {}));
export var TestResult;
(function (TestResult) {
    TestResult.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign(__assign({}, obj), (obj.FunctionExecutionLogs && { FunctionExecutionLogs: SENSITIVE_STRING })), (obj.FunctionErrorMessage && { FunctionErrorMessage: SENSITIVE_STRING })), (obj.FunctionOutput && { FunctionOutput: SENSITIVE_STRING }))); };
})(TestResult || (TestResult = {}));
export var TestFunctionResult;
(function (TestFunctionResult) {
    TestFunctionResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.TestResult && { TestResult: TestResult.filterSensitiveLog(obj.TestResult) }))); };
})(TestFunctionResult || (TestFunctionResult = {}));
export var TagKeys;
(function (TagKeys) {
    TagKeys.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TagKeys || (TagKeys = {}));
export var UntagResourceRequest;
(function (UntagResourceRequest) {
    UntagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UntagResourceRequest || (UntagResourceRequest = {}));
export var UpdateCachePolicyRequest;
(function (UpdateCachePolicyRequest) {
    UpdateCachePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateCachePolicyRequest || (UpdateCachePolicyRequest = {}));
export var UpdateCachePolicyResult;
(function (UpdateCachePolicyResult) {
    UpdateCachePolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateCachePolicyResult || (UpdateCachePolicyResult = {}));
export var UpdateCloudFrontOriginAccessIdentityRequest;
(function (UpdateCloudFrontOriginAccessIdentityRequest) {
    UpdateCloudFrontOriginAccessIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateCloudFrontOriginAccessIdentityRequest || (UpdateCloudFrontOriginAccessIdentityRequest = {}));
export var UpdateCloudFrontOriginAccessIdentityResult;
(function (UpdateCloudFrontOriginAccessIdentityResult) {
    UpdateCloudFrontOriginAccessIdentityResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateCloudFrontOriginAccessIdentityResult || (UpdateCloudFrontOriginAccessIdentityResult = {}));
export var UpdateDistributionRequest;
(function (UpdateDistributionRequest) {
    UpdateDistributionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfig && {
        DistributionConfig: DistributionConfig.filterSensitiveLog(obj.DistributionConfig),
    }))); };
})(UpdateDistributionRequest || (UpdateDistributionRequest = {}));
export var UpdateDistributionResult;
(function (UpdateDistributionResult) {
    UpdateDistributionResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Distribution && { Distribution: Distribution.filterSensitiveLog(obj.Distribution) }))); };
})(UpdateDistributionResult || (UpdateDistributionResult = {}));
export var UpdateFieldLevelEncryptionConfigRequest;
(function (UpdateFieldLevelEncryptionConfigRequest) {
    UpdateFieldLevelEncryptionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateFieldLevelEncryptionConfigRequest || (UpdateFieldLevelEncryptionConfigRequest = {}));
export var UpdateFieldLevelEncryptionConfigResult;
(function (UpdateFieldLevelEncryptionConfigResult) {
    UpdateFieldLevelEncryptionConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateFieldLevelEncryptionConfigResult || (UpdateFieldLevelEncryptionConfigResult = {}));
export var UpdateFieldLevelEncryptionProfileRequest;
(function (UpdateFieldLevelEncryptionProfileRequest) {
    UpdateFieldLevelEncryptionProfileRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateFieldLevelEncryptionProfileRequest || (UpdateFieldLevelEncryptionProfileRequest = {}));
export var UpdateFieldLevelEncryptionProfileResult;
(function (UpdateFieldLevelEncryptionProfileResult) {
    UpdateFieldLevelEncryptionProfileResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateFieldLevelEncryptionProfileResult || (UpdateFieldLevelEncryptionProfileResult = {}));
export var UpdateFunctionRequest;
(function (UpdateFunctionRequest) {
    UpdateFunctionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.FunctionCode && { FunctionCode: SENSITIVE_STRING }))); };
})(UpdateFunctionRequest || (UpdateFunctionRequest = {}));
export var UpdateFunctionResult;
(function (UpdateFunctionResult) {
    UpdateFunctionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateFunctionResult || (UpdateFunctionResult = {}));
export var UpdateKeyGroupRequest;
(function (UpdateKeyGroupRequest) {
    UpdateKeyGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateKeyGroupRequest || (UpdateKeyGroupRequest = {}));
export var UpdateKeyGroupResult;
(function (UpdateKeyGroupResult) {
    UpdateKeyGroupResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateKeyGroupResult || (UpdateKeyGroupResult = {}));
export var UpdateOriginRequestPolicyRequest;
(function (UpdateOriginRequestPolicyRequest) {
    UpdateOriginRequestPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateOriginRequestPolicyRequest || (UpdateOriginRequestPolicyRequest = {}));
export var UpdateOriginRequestPolicyResult;
(function (UpdateOriginRequestPolicyResult) {
    UpdateOriginRequestPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateOriginRequestPolicyResult || (UpdateOriginRequestPolicyResult = {}));
export var UpdatePublicKeyRequest;
(function (UpdatePublicKeyRequest) {
    UpdatePublicKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdatePublicKeyRequest || (UpdatePublicKeyRequest = {}));
export var UpdatePublicKeyResult;
(function (UpdatePublicKeyResult) {
    UpdatePublicKeyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdatePublicKeyResult || (UpdatePublicKeyResult = {}));
export var UpdateRealtimeLogConfigRequest;
(function (UpdateRealtimeLogConfigRequest) {
    UpdateRealtimeLogConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateRealtimeLogConfigRequest || (UpdateRealtimeLogConfigRequest = {}));
export var UpdateRealtimeLogConfigResult;
(function (UpdateRealtimeLogConfigResult) {
    UpdateRealtimeLogConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateRealtimeLogConfigResult || (UpdateRealtimeLogConfigResult = {}));
export var UpdateResponseHeadersPolicyRequest;
(function (UpdateResponseHeadersPolicyRequest) {
    UpdateResponseHeadersPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateResponseHeadersPolicyRequest || (UpdateResponseHeadersPolicyRequest = {}));
export var UpdateResponseHeadersPolicyResult;
(function (UpdateResponseHeadersPolicyResult) {
    UpdateResponseHeadersPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateResponseHeadersPolicyResult || (UpdateResponseHeadersPolicyResult = {}));
export var UpdateStreamingDistributionRequest;
(function (UpdateStreamingDistributionRequest) {
    UpdateStreamingDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateStreamingDistributionRequest || (UpdateStreamingDistributionRequest = {}));
export var UpdateStreamingDistributionResult;
(function (UpdateStreamingDistributionResult) {
    UpdateStreamingDistributionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UpdateStreamingDistributionResult || (UpdateStreamingDistributionResult = {}));
